import { Injectable } from '@angular/core';
import { Adminenvironment, environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';

export interface UserLocation {
  latitude: string | null;
  longitude: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class DeviceInfoService {

  private readonly baseApiRoute = `${Adminenvironment.apiBaseUrl}DeviceInfo`;

  constructor(private http: HttpClient) { }

  private getDeviceInfo() {
    const ua = navigator.userAgent;

    const deviceType =
      /mobile/i.test(ua) ? 'Mobile' :
        /tablet|ipad/i.test(ua) ? 'Tablet' :
          'Laptop';

    let browser = 'Unknown';
    if (ua.includes('Edg')) browser = 'Edge';
    else if (ua.includes('Chrome')) browser = 'Chrome';
    else if (ua.includes('Firefox')) browser = 'Firefox';
    else if (ua.includes('Safari')) browser = 'Safari';

    let operatingSystem = 'Unknown';
    if (ua.includes('Windows')) operatingSystem = 'Windows';
    else if (ua.includes('Android')) operatingSystem = 'Android';
    else if (ua.includes('iPhone') || ua.includes('iPad')) operatingSystem = 'iOS';
    else if (ua.includes('Mac')) operatingSystem = 'MacOS';

    return { deviceType, browser, operatingSystem };
  }

  getLocation(): Promise<UserLocation> {
    return new Promise((resolve, reject) => {

      //   DEV fallback (optional)
      if (!Adminenvironment.production && Adminenvironment.mockLocation) {
        resolve(Adminenvironment.mockLocation);
        return;
      }

      if (!navigator.geolocation) {
        reject('Geolocation not supported');
        return;
      }

      //   Try HIGH accuracy first
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          resolve({
            latitude: String(pos.coords.latitude),
            longitude: String(pos.coords.longitude)
          });
        },
        (error) => {

          //  Fallback LOW accuracy (fix for code 2)
          if (error.code === 2) {
            navigator.geolocation.getCurrentPosition(
              (pos) => {
                resolve({
                  latitude: String(pos.coords.latitude),
                  longitude: String(pos.coords.longitude)
                });
              },
              () => reject('Location unavailable'),
              {
                enableHighAccuracy: false,
                timeout: 20000,
                maximumAge: 60000
              }
            );
          } else {
            reject(error);
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0
        }
      );
    });
  }

  async trackLogin(userId: number, location?: UserLocation): Promise<void> {
    try {
      const device = this.getDeviceInfo();
      const userLocation = location ?? await this.getLocation();

      const payload = {
        employeeId: userId,
        deviceType: device.deviceType,
        browser: device.browser,
        operatingSystem: device.operatingSystem,
        latitude: userLocation.latitude,
        longitude: userLocation.longitude
      };

      await firstValueFrom(this.http.post(this.baseApiRoute, payload));

    } catch (error) {
      console.error('Device tracking failed', error);
    }
  }
}
